const europe_extent = [-36, 15, 43, 90];
const world_extent = [-180, -90, 180, 90];
const tile_url = version =>  `https://tiles.emodnet-bathymetry.eu/${version}/{Layer}/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png`;
const wms_url = 'https://ows.emodnet-bathymetry.eu/wms';
		
export { tile_url, europe_extent, world_extent, wms_url };